import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Flag from 'react-world-flags';
import '../styles/Countries.css';

const Countries = ({ isHomePage = true }) => {
  const navigate = useNavigate();
  
  // Ülke verileri - yeni ülkeler eklendi
  const countries = [
    { id: 'almanya', name: "Almanya", code: "DE", link: "/ulkeler#almanya" },
    { id: 'ingiltere', name: "İngiltere", code: "GB", link: "/ulkeler#ingiltere" },
    { id: 'fransa', name: "Fransa", code: "FR", link: "/ulkeler#fransa" },
    { id: 'hollanda', name: "Hollanda", code: "NL", link: "/ulkeler#hollanda" },
    { id: 'isvec', name: "İsveç", code: "SE", link: "/ulkeler#isvec" },
    { id: 'ispanya', name: "İspanya", code: "ES", link: "/ulkeler#ispanya" },
    { id: 'finlandiya', name: "Finlandiya", code: "FI", link: "/ulkeler#finlandiya" },
    { id: 'luksemburg', name: "Lüksemburg", code: "LU", link: "/ulkeler#luksemburg" },
    { id: 'portekiz', name: "Portekiz", code: "PT", link: "/ulkeler#portekiz" },
    { id: 'romanya', name: "Romanya", code: "RO", link: "/ulkeler#romanya" },
    { id: 'malta', name: "Malta", code: "MT", link: "/ulkeler#malta" },
    { id: 'italya', name: "İtalya", code: "IT", link: "/ulkeler#italya" },
    { id: 'isvicre', name: "İsviçre", code: "CH", link: "/ulkeler#isvicre" },
    { id: 'hirvatistan', name: "Hırvatistan", code: "HR", link: "/ulkeler#hirvatistan" },
  ];

  // Ülkeye tıklandığında programlı olarak yönlendirme ve olay gönderme
  const handleCountryClick = (country) => {
    // Ülkeler sayfasına yönlendir ve hash değerini ayarla
    navigate(`/ulkeler#${country.id}`);
    
    // 200ms sonra özel bir olay tetikle
    setTimeout(() => {
      // CountriesPage tarafından dinlenecek özel olay
      const event = new CustomEvent('countrySelected', {
        detail: country.id
      });
      document.dispatchEvent(event);
    }, 200);
  };

  return (
    <section className="countries">
      <div className="container">
        <div className="section-title">
          <h2>Ülkeler</h2>
        </div>
        <div className="country-grid">
          {countries.map(country => (
            isHomePage ? (
              // Ana sayfada programlı yönlendirme kullan
              <div 
                key={country.id} 
                className="country-item"
                onClick={() => handleCountryClick(country)}
                style={{ cursor: 'pointer' }}
              >
                <div className="country-flag">
                  <Flag code={country.code} height="48" />
                </div>
                <h3>{country.name}</h3>
              </div>
            ) : (
              // Ülkeler sayfasında normal link kullan
              <Link to={country.link} key={country.id} className="country-item">
                <div className="country-flag">
                  <Flag code={country.code} height="48" />
                </div>
                <h3>{country.name}</h3>
              </Link>
            )
          ))}
        </div>
      </div>
    </section>
  );
};

export default Countries;